import { jsx as _jsx } from "react/jsx-runtime";
import { Popover } from '#pplx/frontend/aether/components/Popover/index.js';
import { SourceSuggestionButton } from '#pplx/frontend/apps/ask/ask-input/ask-input-plus-menu/components/SourceSuggestionButton.js';
import { PremiumSourceTooltipContent } from '#pplx/frontend/apps/ask/sources/components/PremiumSourceTooltipContent.js';
import { useSourceLimits } from '#pplx/frontend/apps/ask/sources/hooks/useSourceLimits.js';
import { memo, useCallback, useMemo } from 'react';
export const SourceSuggestionPremiumData = memo(function SourceSuggestionPremiumData({ source, onClick, iconOnly }) {
    const { getSourceLimit } = useSourceLimits();
    const limitReached = useMemo(() => {
        const { remaining } = getSourceLimit(source);
        return remaining <= 0;
    }, [getSourceLimit, source]);
    const handleClick = useCallback(() => {
        onClick(source);
    }, [onClick, source]);
    const button = useMemo(() => {
        return (_jsx("div", { children: _jsx(SourceSuggestionButton, { source: source, onClick: handleClick, disabled: limitReached, iconOnly: iconOnly }) }));
    }, [handleClick, source, limitReached, iconOnly]);
    return (_jsx(Popover, { appearance: "dark", interaction: "hover", triggerElement: button, children: _jsx(PremiumSourceTooltipContent, { source: source }) }));
});
//# sourceMappingURL=SourceSuggestionPremiumData.js.map